import { EXP_CATEGORY_AIRPORT_LOUNGE_ID } from 'constants/experience'
import useExperienceList from 'hooks/Experiences/useExperienceList'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import LineOneWayFlightIcon from 'LuxKit/Icons/line/LineOneWayFlightIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import ExperienceLoungeOffersBannerTile from './ExperienceLoungeOffersBannerTile'

const BannerContainer = styled.div`
  border: 1px solid ${props => props.theme.palette.highlight.primary.normalBackground};
  border-radius: ${props => props.theme.borderRadius.S};
  overflow: hidden;
`

const BannerHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${rem(8)};
  padding: ${rem(12)} ${rem(16)};
  background-color: ${props => props.theme.palette.highlight.primary.lightBackground};
  color: ${props => props.theme.palette.highlight.primary.lightContrast};
`

const BannerHeaderText = styled(BodyText)`
  min-width: 0;
`

const BannerContent = styled.div`
  padding: ${rem(24)};
`

const AU_LOUNGE_IDS = ['cln:ADL', 'cln:BNE', 'cln:CNS', 'cln:MEL', 'cln:PER', 'cln:SYD']

interface Props {
  experience: App.ExperienceOffer
}

function ExperienceLoungeOffersBanner({ experience }: Props) {
  const intl = useIntl()

  const isAU = !!experience.location.countryCode && (experience.location.countryCode === 'AU' || experience.location.countryCode === 'AUS')

  const [listState, lounges] = useExperienceList(isAU ? {
    experienceIds: AU_LOUNGE_IDS,
    showUnlisted: true,
    isLoyaltyEligible: true,
    excludeIds: [experience.id],
    limit: 10,
  } : {
    latitude: experience.location.latitude,
    longitude: experience.location.longitude,
    categoryCodes: [EXP_CATEGORY_AIRPORT_LOUNGE_ID],
    distance: '80KM',
    showUnlisted: true,
    isLoyaltyEligible: true,
    excludeIds: [experience.id],
    limit: 10,
  })

  if (listState.fetching || lounges.length === 0) {
    return null
  }

  return (
    <BannerContainer>
      <BannerHeader>
        <LineOneWayFlightIcon size="S" />
        <BannerHeaderText variant="medium">
          {intl.formatMessage({
            id: '5Aj_R-MYXRa-RCNSlHhB',
            defaultMessage: 'Flying to a different airport? Select a lounge below',
            description: 'Banner label shown next to the star icon at the top of the lounge cross-sell section on the Collinson experience offer page',
          })}
        </BannerHeaderText>
      </BannerHeader>
      <BannerContent>
        <CardCarousel pageSize={2} width="85%">
          {lounges.map((lounge, index) => (
            <ExperienceLoungeOffersBannerTile
              key={lounge.id}
              experience={lounge}
              position={index}
            />
          ))}
        </CardCarousel>
      </BannerContent>
    </BannerContainer>
  )
}

export default ExperienceLoungeOffersBanner
